/**
 * 出货组件 Modal Shipment
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 *
 **/
import React from "react";
import { Spin, message} from 'antd';
import Lang from '@components/Lang/Lang';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import EssaModal from '@components/EssaModal/EssaModal';
import FormFormat from '@/components/FormFormat/FormFormat';
import LogisticsCompanyList from '@//components/batchPickUpPoDrawer/stepSecond/logisticsCompanyList/logisticsCompanyList';//物流
import {isEmpty,isEmptyObject} from "@utils/utils";
import TakeDeliveryAction from "../../TakeDelivery.action";
import Address from "./Address";//收货人
import dayjs from 'dayjs';
import Tips from "../Tips"
import './index.less'
export default class ModalShipment extends React.Component{
    static defaultProps = {
        deliveryOrderId:"",
        item:{

        },
        flagAdd:true,
        disabled:false, //是否禁用出货，默认否，即可出货
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading:false,
            deliveryDetail :{},// 接口查询回来的出货详情
            logisticsCompanyContactList:[],// 选择的推荐物流联系人列表
            // 表单项
            options:[
                {
                    name:'contactName',
                    cnTitle:'联系人姓名',
                    cnTitleId:'LianXiRenXingMing',
                    // required:true
                },{
                    name:'contactMobile',
                    cnTitle:'联系电话',
                    cnTitleId:'LianXiDianHua',
                    type:"AreaPhone",
                    nameTelephoneCode:"contactTelCode"
                    // required:true
                },{
                    name:'carNumber',
                    cnTitle:'车牌号',
                    cnTitleId:'ChePaiHao',
                },
                {
                    name:'deliveryFileList', // 上传凭证 传到接口
                    cnTitleId:'ShangChuanChuHuoZhaoPian',
                    cnTitle:'上传出货照片',
                    cnPlaceholderId:'ShangChuanChuHuoZhaoPianWenJianTiShi',
                    type:'UploadFileIcon',
                    accept:'.mp4,.flv,.jpeg,.jpg,.png,.bmp,.zip',
                    // 图片/视频 (mp4,flv,jpeg,jpg,png,bmp,zip)，单个文件不能超过50M，最多20个
                    topTips:<div className={"font_12 black45 m-under mb_4"}>{Lang({id:"ShangChuanChuHuoZhaoPianWenJianTiShi",
                        default:"图片/视频 (mp4,flv,jpeg,jpg,png,bmp,zip)，单个文件不能超过50M，最多20个"})}
                    </div>,
                    maxCount: 20,
                    fileSizeLimit: 50*1024*1024,
                },
            ],
            show:false,
            optionsTwo:[
                {   name:'logisticsCompanyName',
                    cnTitle:'物流公司名字',
                    cnTitleId:'WuLiuGongSiMingCheng',
                    // required:true
                },{   name:'logisticsNumber',
                    cnTitle:'物流单号',
                    cnTitleId:'WuLiuDanHao',
                },{
                    name:'contactName',
                    cnTitle:'司机姓名',
                    cnTitleId:'SiJiXingMing',
                },{
                    name:'contactMobile',
                    cnTitle:'联系电话',
                    cnTitleId:'LianXiDianHua',
                    type:"AreaPhone",
                    nameTelephoneCode:"contactTelCode"
                },{
                    name:'carNumber',
                    cnTitle:'车牌号',
                    cnTitleId:'ChePaiHao',
                }, {
                    name:'deliveryFileList', // 上传凭证
                    cnTitleId:'ShangChuanChuHuoZhaoPian',
                    cnTitle:'上传出货照片',
                    cnPlaceholderId:'ShangChuanChuHuoZhaoPianWenJianTiShi',
                    type:'UploadFileIcon',
                    accept:'.mp4,.flv,.jpeg,.jpg,.png,.bmp,.zip',
                    // 图片/视频 (mp4,flv,jpeg,jpg,png,bmp,zip)，单个文件不能超过50M，最多20个
                    topTips:<div className={"font_12 black45 m-under mb_4"}>{Lang({id:"ShangChuanChuHuoZhaoPianWenJianTiShi",
                        default:"图片/视频 (mp4,flv,jpeg,jpg,png,bmp,zip)，单个文件不能超过50M，最多20个"})}
                    </div>,
                    maxCount: 20,
                    fileSizeLimit: 50*1024*1024,
                },
            ],
        }
    }
    /**
     * 打开
     * */
    showModal = (flag=true,type) => {
        if(flag){
            this.loading(true);
            this.setState({
                show:false,
            })
            // 如果 类型为3，查询 deliveryDetail
            TakeDeliveryAction.deliveryDetail({
                deliveryOrderId:this.props.deliveryOrderId
            }).then(res=>{
                this.loading(false)
                const resData = res.data;
                const { success,valid, model={} } = resData;
                const list = model.logisticsCompanyList||[];
                const curr = list.find(item=>item.id== model.logisticsCompanyId)||{};
                if(success&&valid){
                    this.setState({
                        deliveryDetail: model,
                        logisticsCompanyId: model.logisticsCompanyId,
                        logisticsCompanyContactList:curr&&curr.type==1?(curr.logisticsCompanyContactList||[]):[],//推荐物流显示联系人
                    },()=>this.setState({
                        show:true,
                    }))
                }else this.setState({
                    show:true,
                })
            })
        }
        this.setState({
            visible: flag,
        });
    };
    // 初始化
    loading(flag){
        this.setState({
            loading:flag
        })
    }

    /**
     * 点击确认时 获取表单数据
     ***/
    async handleOK(){
        const res = await this.onRefFormFormat.handleOK();
        if(res&&res.success){
            let values = res.data;
            values["deliveryOrderId"] = this.props.deliveryOrderId;
            if(this.state.logisticsCompanyId){
                values["logisticsCompanyId"] = this.state.logisticsCompanyId;
            }
            // if(values.deliveryFiles&&values.deliveryFiles.length>0){
            //     let deliveryFileids = []
            //     values.deliveryFiles.forEach(item=>{
            //         deliveryFileids.push(item.fileId)
            //     })
            //     values["deliveryFileids"] = deliveryFileids;
            //     delete values.deliveryFiles;
            // }
            this.loading(true)
            const { flagAdd,} = this.props;
            let sUrl = ""
            if(flagAdd){
                sUrl = '/service/mg/whs/delivery/stock-out';
            }else { // 编辑
                const { deliveryDetail } = this.state;
                sUrl = '/service/mg/whs/delivery/stock-out-update';
                values["id"] = deliveryDetail.deliveryOrderConfirmId;
            }
            TakeDeliveryAction.stockOut(values,sUrl).then((res)=>{
                const resData =res.data;
                this.loading(false)
                const { success, valid} = resData;
                if (success &&valid) {
                    // 保存成功
                    this.showModal(false)
                    if(this.props.refreshPage)this.props.refreshPage();// 刷新 页面数据
                }else if(resData.message){
                    message.info(resData.message);
                }else message.info(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
            })
        }
    }
    /**
     * 点击物流
     * */
    setLogistics(company={}){
        const logisticsCompanyContactList = company.logisticsCompanyContactList||[];
        this.setState({
            logisticsCompanyId:company.id,
            logisticsCompanyContactList:company.type==1?logisticsCompanyContactList:[],//只有推荐物流显示联系人
        })
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    renderOptionThree(deliveryDetail){
        return [
            {
                name:'logisticsNumber',
                cnTitle:'物流单号',
                cnTitleId:'WuLiuDanHao',
                required:true,
            }, {
                name:"consigneeInfo",
                type:"OnlyRender",
                onlyRender:<Address address={deliveryDetail} />,
            },
            {
                name:'deliveryFileList', // 上传凭证
                cnTitleId:'ShangChuanChuHuoZhaoPian',
                cnTitle:'上传出货照片',
                cnPlaceholderId:'ShangChuanChuHuoZhaoPianWenJianTiShi',
                type:'UploadFileIcon',
                accept:'.mp4,.flv,.jpeg,.jpg,.png,.bmp,.zip',
                topTips:<div className={"font_12 black45 s-under mb_4"}>{Lang({id:"ShangChuanChuHuoZhaoPianWenJianTiShi",
                    default:"图片/视频 (mp4,flv,jpeg,jpg,png,bmp,zip)，单个文件不能超过50M，最多20个"})}
                </div>,
                maxCount: 20,
                fileSizeLimit: 50*1024*1024,
            },
        ]
    }
    componentWillMount(){
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    };
    componentWillUnmount() {

    }
    render() {
        const { visible, loading, options,optionsTwo,logisticsCompanyId,deliveryDetail,logisticsCompanyContactList,show } = this.state;
        const {item, deliveryOrderId, flagAdd,disabled } = this.props;
        const type = item.type;
         return (<>
            {/*<AuthBtn icon={"ri-article-line"} tips = {Lang({id:"XiangQing",default:"详情"})}*/}
                     {/*onClick={()=>this.showModal(true)}/>*/}
            {disabled?<AuthBtn className={"btnSendDisabled ml_8"}
                               tips = {Lang({id:"WeiZhiFuBuYunXuChuKu",default:"未支付，不允许出库"})}
                               title={flagAdd?Lang({id:"ChuHuo",default:"出货"}):Lang({id:"BianJi",default:"编辑"})}
                                />:<AuthBtn className={"btnSend ml_8"}
                     tips = {Lang({id:"WuLiu",default:"物流"})}
                     title={flagAdd?Lang({id:"ChuHuo",default:"出货"}):Lang({id:"BianJi",default:"编辑"})}
                     onClick={()=>this.showModal(true,type)} />}
             <EssaModal title={Lang({id:"ChuHuo",default:"出货"})}
                        open={visible}
                        closable={false}
                        width={600}
                        onCancel={()=>this.showModal(false)}
                        onOk={()=>this.handleOK()} >
                <Spin spinning={loading}>
                    <div className={"modalShipment"}>
                        <p><span className={"black89 fw_700"}>{item.preDeliveryDate?dayjs(item.preDeliveryDate).format("YYYY-MM-DD"):"-"}</span>
                            <span className={"black66 ml_4"}>{item.buyerCode}</span>
                        </p>
                        {/*  中转城市名称  预约类型名称 */}
                        <Tips item={item} className={"mb_14"} />
                        {type=="30"&&<>
                            <p className={"black89 mb_12"}>
                                {Lang({id: 'QueRenWuLiuGongSi', default: '确认物流公司'})}
                            </p>
                            {deliveryDetail&&deliveryDetail.logisticsCompanyList&&<LogisticsCompanyList logisticsCompanyList={deliveryDetail.logisticsCompanyList}
                                                                                                        canClick={true}
                                                                                                        onClickLogistics={(item)=>this.setLogistics(item)}
                                                                                                        showIntroduce={false}
                                                                                                        className={"mt_12 logoHalf"}
                                                                                                        logisticsCompanyId={logisticsCompanyId} />}
                            {logisticsCompanyContactList.length>0&&<>
                                {logisticsCompanyContactList.map((item,inx)=><div key={"dContact"+inx} className={"conContact black89 font_14"}>
                                    <p>{item.name}</p>
                                    <p className={"fw_500"}>+{item.telCode}<span className={"ml_4"}>{item.mobile}</span></p>
                                </div>)}
                            </>}
                        </>}
                        {/* 表单 */}
                        {show&&<FormFormat onRef={this.onRefForm}
                                    name={"modalShipmentForm"}
                                    options={type=="10"?options:(type=="20"?optionsTwo:this.renderOptionThree(deliveryDetail))}
                                    formLayout="vertical"
                                    initialValues={deliveryDetail}  />}


                    </div>
                </Spin>
            </EssaModal>
        </>);
    }
}

